import React from "react";

export const FormHeader = ({ children }) => (
  <div style={{ display: "flex" }}>
    <div className="reporting__heading">{children}</div>
  </div>
);
